import type { BackendErrorPayload } from "@/components/document-chat/services/streamEventTypes";
import { isBackendErrorPayload } from "@/components/document-chat/services/streamEventTypes";
import { ChatStatus, StreamPhase } from "@/constants/enums";
import { tryParseJSON } from "@/components/document-chat/utils";
// Types are globally available from @/types/chat-sse.d.ts
import type { DocumentChatRuntime } from "../types";
import type { TFunction } from "i18next";

/**
 * Handles error events from the backend
 *
 * @param dataStr - The error event data string
 * @param session - The current stream session
 * @param runtime - The document chat runtime store interface
 * @param cancel - Function to cancel the stream
 * @param t - Translation function
 */
export function handleErrorEvent(
  dataStr: string,
  session: StreamSession,
  runtime: DocumentChatRuntime,
  cancel: () => void,
  t: TFunction
): void {
  const payload = tryParseJSON<BackendErrorPayload>(dataStr);
  const errorMessage = isBackendErrorPayload(payload)
    ? payload.message
    : t("documentchat.streamedresponse.error.processingerror");
  console.error("Error event received:", errorMessage);
  session.hasError = true; // Mark that we've encountered an error
  runtime.update({ status: ChatStatus.ERROR, error: errorMessage, phase: StreamPhase.DONE });
  // Cancel the stream since we have an error
  try {
    cancel();
  } catch (_e) {
    /* noop */
  }
}
